<template>
  <div class="w-full">
    <input v-validate="validationRule" :name="field" :id="field" type="checkbox" v-model="fieldModel" v-if="!disabled">
    <input :name="field" :id="field" type="checkbox" :checked="fieldModel" v-if="disabled" :disabled="true">
    <label class="checkbox-label leading-normal" :for="field" v-html="label"></label>
    <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">{{ validationMessage }}</p>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FieldCheckbox',
  inject: ['$validator'],
  data() {
    return {
      value: '',
    };
  },
  props: {
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    connectedField: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    validationRule: {
      default: '',
    },
    validationMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resetFieldsChecked: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fieldModel: {
      get() {
        if (!this.connectedField) {
          return this.value;
        }
        return _.get(this.$store.state[this.namespace], this.field);
      },
      set(value) {
        if (!this.connectedField) {
          this.value = value;
          return true;
        }
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });

        if (this.resetFieldsChecked.length > 0) {
          this.resetFieldsChecked.map(f => this.$store.commit(`${this.namespace}/resetField`, {
            // if replacement field is [2] it doesn't exist in default state in vuex, always replace
            // with [0]
            field: f,
            initStateField: f.replace(/\[[1-9]\]/, '[0]'),
          }))
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
@tailwind utilities;
.checkbox-label {
  @apply .text-navy-light .mb-2 .inline-block .align-top;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldCheckbox.vue